import { Component, Input, OnInit, Output} from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';

@Component({
  selector: 'atw-video-repeat-config',
  templateUrl: './video-repeat-config.component.html',
  styleUrls: ['./video-repeat-config.component.scss']
})
export class AtwVideoRepeatConfig implements OnInit {
  @Input() device: any;
  @Input() config: any;
  @Input() type: any; // xem đang ở page hay admin
  @Input() objectChoosing: any = {};
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any; // biến lưu phần tử được chọn của mảng style_field
  styles_field = [
    {
      title: 'bo_goc',
      index: 1
    }
  ];

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhEventMediator:VhEventMediator,
  ) { }
  
  ngOnInit(): void {}

  //Hàm update class
  private updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
      })
  }

  /**
  * Hàm này dùng để mở rộng phần cấu hình.
  * @param field_text : trả về phần tử được chọn của mảng style_field
  */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event){
    if(event.width) this.class['video']['width'] = event.width + 'px';
    if(event.height) this.class['video']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }
}
